import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { Order, OrderFilters } from '@models/order'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import ordersApi from './actions'
import { ordersKeys } from './constants'

export interface UseOrdersProps {
  orders: Omit<Order, 'notes'>[]
  ordersMap: Map<number, Omit<Order, 'notes'>>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Omit<Order, 'notes'>>): UseOrdersProps => {
  return {
    orders: data,
    ordersMap: new Map(data.map(order => [order.id, order])),
    pagination,
  }
}

const useOrders = (filters: OrderFilters) => {
  const query = useQuery<
    PaginatedResponse<Omit<Order, 'notes'>>,
    AxiosError,
    UseOrdersProps
  >(ordersKeys.orders(filters), () => ordersApi.getOrders(filters), {
    select: selectData,
    enabled: !!filters.companyId,
  })

  return query
}

export default useOrders
